import { useAuth } from "@/src/contexts/auth.context";
import { usePathname, useRouter } from "expo-router";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ConfirmModal from "@/src/components/action-modals/confirm-modal";
import MobileBottomNav from "@/src/components/ui-kit/nav-bar/bottom-nav-bar";
import NavBar from "@/src/components/ui-kit/nav-bar/nav-bar";

import {
  clearTokens,
  getRefreshToken,
  getToken,
  useLogoutMutation,
  webServerLogout,
} from "@/src/services/api/auth.api";
import { Platform, useWindowDimensions } from "react-native";
import { useTheme } from "@/src/styles/theme-provider";

const NavigationWrapper = () => {
  const { user } = useAuth();
  const { themeVars } = useTheme();
  const { t } = useTranslation();
  const router = useRouter();
  const pathname = usePathname();
  const { width: windowWidth } = useWindowDimensions();

  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const logoutMutation = useLogoutMutation();

  const isActive = (path: string) => {
    if (path === "/") return pathname === "/";
    return pathname === path || pathname.startsWith(`${path}/`);
  };

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      const refreshToken = await getRefreshToken();
      const accessToken = await getToken();

      if (refreshToken && accessToken) {
        await logoutMutation.mutateAsync({ refreshToken, accessToken });
      } else if (Platform.OS === "web") {
        await webServerLogout();
      }

      await clearTokens();
      router.replace("/login");
    } catch (error) {
      console.error(t("ERROR_LOGOUT_FAILED"), error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const isMobile = windowWidth < 768;

  return (
    <>
      {isMobile ? (
        <MobileBottomNav
          isActive={isActive}
          user={user}
          t={t}
          router={router}
          onLogoutPress={() => setShowLogoutModal(true)}
          isLoggingOut={isLoggingOut}
        />
      ) : (
        <NavBar />
      )}

      <ConfirmModal
        visible={showLogoutModal}
        title="LABEL_LOGOUT_CONFIRM"
        description="HINT_LOGOUT_CONFIRM"
        confirmText={t("BTN_LOGOUT")}
        cancelText={t("BTN_CANCEL")}
        onCancel={() => setShowLogoutModal(false)}
        onConfirm={async () => {
          setShowLogoutModal(false);
          handleLogout();
        }}
      />
    </>
  );
};

export default NavigationWrapper;
